<template>
    <div class="dynamic-container">
        <div class="header">
            <div class="header-name">
                <div class="header-title">Guided questions with Dynamic Intelligence
                    <Svg :src="require('@/assets/icons/star.svg')" fill="white"> </Svg>
                </div>
                <div class="header-note">
                    <Svg :src="require('@/assets/icons/info-icon.svg')" fill="white" height="16" width="16"> </Svg>
                    Click the boxes that you want included

                </div>
            </div>
            <div class="header-subtitle">Designed to provide you with more depth, detail, research and stronger framing
            </div>

        </div>
        <div class="body">
            <v-progress-circular v-if="quesLoader" indeterminate :size="25" :width="2"
                color="red"></v-progress-circular>
            <div class="ques-ans-container" v-for="(qn, index) in dynamicQuestion" v-else>
                <input type="checkbox" :checked="qn.isSelected" @change="onToggle(index, $event.target.checked)"
                    class="select-box"></input>
                <div class="ques-ans-wrapper">
                    <div class="ques-ans">
                        <div class="btn-head">
                            <div class="ques">
                                {{ index + 1 }}. {{ qn.question }}
                            </div>
                            <div>
                                <button class="regenerate-btn" :disabled="regenerateLoader[index]"
                                    @click="handleRegenerateQuestion(index)">
                                    <p>Regenerate with <Svg :src="DiamondIcon" fill="#DF009E"></Svg> 2</p>
                                    <v-progress-circular v-if="regenerateLoader[index]" indeterminate :size="15"
                                        :width="2" color="#DF009E"></v-progress-circular>
                                </button>
                            </div>
                        </div>
                        <v-textarea v-model="qn.draftAnswer" variant="outlined" density="compact"
                            hide-details></v-textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StarIcon from '@/assets/icons/star.svg';
import DiamondIcon from '@/assets/icons/diamond.svg';
import axiosInstance from '@/axiosInterceptor';
import { saveDraft } from '@/helper/saveAsDraft';
export default {
    props: {
        userInputQuestions: {
            type: Array
        },
        subtitle: {
            type: String
        },
        modelValue: {
            type: Array
        },
        prTypeId: {
            type: String,
            required: true
        },
        inputId: {
            type: String,

        }
    },
    data() {
        return {
            StarIcon, DiamondIcon,
            selectedQues: [],
            quesLoader: false,
            regenerateLoader: [],
        }
    },
    computed: {
        dynamicQuestion: {
            get() {
                return this.modelValue;
            },
            set(updatedList) {
                this.$emit('update:modelValue', updatedList);
            }
        }
    },

methods: {

        async handleRegenerateQuestion(index) {
        let serviceType;
        this.regenerateLoader[index] = true;

        if (this.subtitle === 'Article') {
            serviceType = "ARTICLE"
        }
        else {
            serviceType = "PR"
        }
        let regenerateQuestionPayload = {
            inputId: this.inputId,
            questionToBeChanged: this.dynamicQuestion[index].question,
            serviceType: serviceType
        }
        await axiosInstance.put('/regenerate/dynamicQuestions', regenerateQuestionPayload)
            .then(async (response) => {
                this.dynamicQuestion[index].question = response.data.data.questions[0].question;
                this.dynamicQuestion[index].draftAnswer = response.data.data.questions[0].draftAnswer;
                this.dynamicQuestion[index].selected = false;

                if (this.subtitle === 'Press Release') {
                    let dynamicQuestionPayload = {
                        prId: this.$route.params.prId,
                        typeId: this.prTypeId,
                        dynamicUpdateAnswer: this.dynamicQuestion,
                        updatedAnswer: this.userInputQuestions
                    }
                    await saveDraft(dynamicQuestionPayload);
                } else {
                    let payload = {};
                    payload.articleId = this.$route.params.articleId;
                    payload.lastUpdatedStage = 'DYN_ARTICLE';
                    payload.dynamicContentWithQuestion = {
                        articleDynamicQuestions: this.dynamicQuestion
                    }
                    let result = axiosInstance.put('/article/saveDraft', payload)
                }

            })
            .catch((error) => {
                console.error('Error while fetching Refining dynamic question', error);
            })
            .finally(() => {
                this.regenerateLoader[index] = false;

            })
    },

    onToggle(index, checked) {
        const updated = [...this.dynamicQuestion];
        updated[index].isSelected = checked;
        this.dynamicQuestion = updated;
    }
}
}
</script>

<style scoped>
.dynamic-container {
    width: 100%;
    max-width: 1024px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 24px 8px 40px 8px;
}

.header {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    gap: 4px;
}

.header-title {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    align-items: center;
    display: flex;
    flex-direction: row;
    color: #FAFAFA;
}

.header-note {
    display: flex;
    border-radius: 4px;
    color: var(--secondary-font-color);
    gap: 4px;
    padding: 0.5rem;
    background-color: rgba(255, 255, 255, 0.08);
    justify-content: center;
    align-items: center;

}

.header-name {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    gap: 8px;
}

.header-subtitle {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #E5E5E5;
}

.body {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.btn-head {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: space-between;
}

.ques-ans-container {
    display: flex;
    gap: 16px;
    align-items: baseline;
}

.select-box {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid white;
    border-radius: 2px;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
}

.select-box:checked {
    background-color: #DF009E;
    border-color: #DF009E;
}

.select-box:checked::after {
    content: '';
    background-image: url('@/assets/icons/tick-icon.svg');
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.ques-ans-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #D4D4D4;
    background: #FFFFFF;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    border-radius: 8px;
}

.ques-ans {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 1.2em 2em;
}

.ques {
    color: #171717;
    font-size: 16px;
    font-weight: 500;
}

.ans-wrapper {
    border: 1px solid #D4D4D4;
    background: #F5F5F5;
    border-radius: 4px;
    padding: 20px;
    color: #262626;
    font-size: 16px;
    font-weight: 400;
}

.marked {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.regenerate-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 3px 12px;
    border: 1px solid #DF009E;
    color: #DF009E;
    border-radius: 4px;
    font-size: 14px;
    width: 11rem;
}

.regenerate-btn p {
    background-image: var(--primary-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
}

.dislike {
    transform: rotate(180deg);
}
</style>